<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
      :disabled="readonly"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="formattedPeriodo"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :clearable="clearable"
          @click:clear="onClearPeriodo"
          :hint="hint"
          :persistent-hint="persistentHint"
          :dense="dense"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="periodo"
        type="month"
        no-title
        scrollable
        locale="es"
        @change="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment';
import PeriodoMixin from '@/mixins/Periodo';
export default {
  name: 'MonthPickerComponent',
  mixins: [PeriodoMixin],
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Periodo',
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      fechaFrom: null,
      fechaTo: null,
      periodo: null,
      menu: false,
    };
  },
  computed: {
    formattedDate: {
      get () {
        return this.periodo ? this.$moment(this.periodo).format('YYYY-MM') : null;
      },
      set (value) {
        this.periodo = this.$moment(value).format('YYYY-MM-DD');
      },
    },
    formattedPeriodo () {
      return this.fechaTo ? this.$moment(this.fechaTo).format('MMMM/YYYY') : '';
    },
    persistentHint () {
      return this.fechaFrom !== null;
    },
    hint () {
      if (!this.fechaFrom && !this.fechaTo) {
        return '';
      }
      else {
        return this.$moment(this.fechaFrom).format('DD/MM/YYYY') + ' - ' + this.$moment(this.fechaTo).format('DD/MM/YYYY');
      }
    }
  },
  watch: {
    async formattedDate (newValue) {
      if (!newValue) {
        this.$emit('change', null);
      };
      let fechaTo = await this.periodoFechaTo(newValue);
      this.$emit('change', fechaTo);
    },
    async selected (newValue) {
      if (!newValue) {
        this.fechaFrom = null
        this.fechaTo = null
      } else {
        this.fechaFrom = await this.periodoFechaFrom(newValue);
        this.fechaTo = await this.periodoFechaTo(newValue);
      }
    }
  },
  methods: {
    onClearPeriodo (event) {
      event.preventDefault()
      this.fechaFrom = null;
      this.fechaTo = null;
      this.$emit('change', null);
    },
  },
};
</script>
